import { DetailsDisclosure } from '@/scripts/theme/details-disclosure';
import { TsDOM as q } from '@/scripts/core/TsDOM'
import {
  scaleValue,
} from '@/scripts/core/global'
import {type StickyHeader } from '@/scripts/theme/sticky-header';
import { SELECTORS } from '@/scripts/core/global';

export class HeaderMenu extends HTMLElement {
  static htmlSelector = 'header-menu'
  header: StickyHeader | null
  megaMenu: HTMLElement
  toggleMenu: HTMLLinkElement
  megaMenuContent: HTMLElement
  detailsId?: string
  constructor() {
    super()
    this.header = q.rs<StickyHeader>(SELECTORS.headerWrapper)
    this.megaMenu = q.rs('.mega-menu', this)
    this.megaMenuContent = q.rs('.mega-menu__content', this)
    this.toggleMenu = q.rs('.header__menu-item', this)
    this.detailsId = q.oa(this.megaMenu, 'id')
    this.toggleMenu.addEventListener('mouseenter', this.openMenu.bind(this))
    this.toggleMenu.addEventListener('focusin', this.openMenu.bind(this))
  }

  openMenu() {
    q.rl('.mega-menu').forEach(menu => {menu.removeAttribute('open')})
    this.megaMenu.setAttribute('open', '')
    window.Ucoast.openMenuId = this.detailsId
    this.onToggle()
  }

  closeMenu() {
    this.megaMenu.removeAttribute('open')
    this.onToggle()
  }

  onToggle() {
    if (!this.header) return

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return
    const viewport = window.innerWidth >= 750 ? 'desktop' : 'mobile'
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `calc(${scaleValue(this.header.getBoundingClientRect().bottom, viewport)} * var(--ax))`
    )
  }
}
